import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '.../../environments/environment';
import { AuthService } from '../../../_services/index';
import { LoaderService } from 'app/_services/loader.service';
import { utils, write, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { process, State } from '@progress/kendo-data-query';
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { Observable } from 'rxjs';
declare var $: any;

import * as _moment from 'moment';  
import * as _rollupMoment from 'moment'; 
const moment = _rollupMoment || _moment;

const distinctCat = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.CATNAME === x.CATNAME) === idx);
const distinctSubCat = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.SUBCATNAME === x.SUBCATNAME) === idx);
const distinctPartType = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.PARTTYPENAME === x.PARTTYPENAME) === idx);
const distinctUOM = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.UOMTYPENAME === x.UOMTYPENAME) === idx);

@Component({
  selector: 'plantData',
  templateUrl: './plantData.component.html'
})
export class plantDataComponent {
  public distinctCat: any[];
  public distinctSubCat: any[];
  public distinctPartType: any[];
  public distinctUOM: any[];
  search: any;
  prjId: any;
  showLoader: boolean;
  requestedPlantData: any;
  vehMaintUOMList: any;
  priceModal: any;
  uomModal: any;
  serviceModal: any;
  partModal: any;
  quantityModal: any;
  upQuantityModal: any;
  saveSuccess = false;
  errorInSuccess = false;
  userId: any;
  respMsg: any;
  selectedRow: number;
  maintMstDataNotFound = false;
  vehiclesCatogeryList: any;
  vehiclesTypeList: any;
  vehCotegaryId: any;
  vehTypeId: any;
  partCode: any;
  imgLoaderPath: any;
  entityCodeLoaderDiv = false;
  isVehicleUpdtbtn = false;
  newPartCode: any;
  isBtnSave = false;
  categoryList: any;
  partTypeList: any;
  categoryId: any;
  partModalData: any;
  typeModal: any;
  categoryModal: any;
  subCategoryModal: any;
  newCategory: any;
  categoryCreateMsg: any;
  categorySuccess = false;
  categoryError = false;
  newSubCategory: any;
  subCatError = false;
  subCatSuccess = false;
  newPartTypeModal: any;
  partSuccess = false;
  partError = false;
  itemToUpdate: any;
  upCategoryModal: any;
  upTypeModal: any;
  upPartModal: any;
  upUomModal: any;
  upPriceModal: any;
  upSubCategoryModal: any;
  CATNAME: string;
  partCodeModal: any;
  syncing: any;
  public roleList: any;
  loaderClass: any;
  vTypeModel: any;
  vSubCategoryModal: any;
  vCategoryModal: any;

  public groups: GroupDescriptor[] = [];
  public view: Observable<GridDataResult>;
  public gridView: DataResult;
  newQuantityModal: any;
  newPriceModal: any;
  public wrongQuantity: boolean = false;
  vendorModal: any;
  invoiceModal: any;
  inwardModal: any;
  invoiceDateModal: any;
  cityList: Object;
  matList: Object;
  matType: Object;
  cityCode: any;
  supplierList: Object;
  SupplierName: any;
  partyList: Object;
  zoneList: Object;
  MaterialType: any;
  CityName: any;
  prjName: string;
  inWt: any;
  outWt: any;
  netWt: any;
  userName: string;
  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
    this.loadProducts();
  }

  public state: State = {
    skip: 0,
    take: 50,
    filter: {
      logic: 'and',
      filters: []
    }
  };
  vUomModel: any;
  selectedCatID: any;
  selectedSubCatID: any;
  selectedUomID: any;
  selectedTypemID: any;
  oneCatID: any;
  oneSubCatID: any;
  oneUomID: any;
  oneTypeID: any;
  newSubCategoryList: any;

  private loadProducts(): void {
    this.gridinventory = process(this.requestedPlantData, { group: this.groups });
  }
  public gridinventory: GridDataResult;

  constructor(
    private auth: AuthService,
    private http: HttpClient,
    private loaderService: LoaderService,
    public router: Router
  ) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridinventory = process(this.requestedPlantData, this.state);
    if (state && state.group) {
      this.gridinventory = process(this.requestedPlantData, this.state);
    }
  }

  getRequestedData() {
    this.loaderService.display(true);
    this.http.get(environment.apiUrl + 'rectification/getRequestedPlantData?city=' + this.prjName).subscribe((data) => {
      this.requestedPlantData = data;
      console.log('all data', this.requestedPlantData);
      if (this.requestedPlantData.length > 0) {
        this.gridinventory = process(this.requestedPlantData, this.state);
        this.distinctCat = distinctCat(this.requestedPlantData);
        this.distinctSubCat = distinctSubCat(this.requestedPlantData);
        this.distinctPartType = distinctPartType(this.requestedPlantData);
        this.distinctUOM = distinctUOM(this.requestedPlantData);
        this.maintMstDataNotFound = false;
        this.loaderService.display(false);
      } else {
        this.maintMstDataNotFound = true;
        this.loaderService.display(false);
        this.gridinventory = process(this.requestedPlantData, this.state);
      }
    });
  }

  updateData(data, status){
    this.clearAllFields()
    this.inWt = data.InWeight
    this.outWt = data.OutWeight
    this.netWt = data.NetWeight
    var statusID = status == 'approve' ? 1 : 2
    console.log(status);
    let approveDate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
    var updatedData = {
      status : statusID,
      id : data.ID,
      usermame : this.userName,
      approveDate : approveDate
    }

    Swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: `Yes, ${status} it!`
    })
    .then((result) => {
      if (result.value) {
        this.http.post(environment.apiUrl + 'rectification/approvePlantData', updatedData).subscribe((data) => {
          var response: any;
          response = data;
          // $('#changeState').modal('hide');
          if (response[0].code == 400) {
            Swal({
              type: 'warning',
              title: response[0].msg,
              showConfirmButton: false,
              timer: 10000
            });
            this.getRequestedData();
          } else {
            Swal({
              type: 'success',
              title: response[0].msg,
              showConfirmButton: false,
              timer: 10000
            });
            this.getRequestedData();
          }
        });
      }
    });
  }

  // updateDataSet(){
  //   var data
  //   data = {
  //     inWt : this.inWt,
  //     outWt : this.outWt,
  //     netWt : this.netWt,
  //   }
  //   this.http.post(environment.apiUrl + 'rectification/updatePlantData', data).subscribe(data =>{ 
  //     if(data[0].code == 200){
  //       Swal({
  //         type: 'success',
  //         title: 'Success',
  //         text: data[0].msg,
  //       })
  //     }
  //   })
  // }

  syncData() {
    this.syncing = true;
    this.loaderClass = 'fas fa-sync fa-spin';
    this.http.get(environment.apiUrl + 'maintenance/getMaintenanceMaster?prjid=' + this.prjId).subscribe((data) => {
      this.syncing = false;
      this.loaderClass = 'fas fa-sync';
    });
    console.log("Refresh")
  }

  clearAllFields() {
    this.categoryModal = null;
    this.partModal = null;
    this.quantityModal = null;
    this.subCategoryModal = null;
    this.typeModal = null;
    this.uomModal = null;
    this.priceModal = null;
  }

  selectRowIndex(data, index) {
    this.selectedRow = index;
  }

  public restrictNumeric(e) {
    let input;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
      return true;
    }
    if (e.which === 0) {
      return true;
    }
    if (e.which < 33) {
      return true;
    }
    input = String.fromCharCode(e.which);
    return !!/[\d\.\s]/.test(input);
  }

  downloadExcelFile(vehicleInfoData) {
    const ws_name = 'VehicleInfo';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(vehicleInfoData);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
    saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'VehicleInfo.xlsx');
  }
  s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  }

  ngOnInit() {
    this.prjId = this.auth.getAuthentication().projectId;
    this.userId = this.auth.getAuthentication().id;
    this.userName = this.auth.getAuthentication().userName;
    if(this.prjId==1){
      this.prjName="LUCKNOW";
    }
    else if(this.prjId==2){
      this.prjName="GURUGRAM";
    }
    else if(this.prjId==3){
      this.prjName="FARIDABAD"; 
    }
    else if(this.prjId==4){
      this.prjName="GWALIOR";
    } 
    this.getRequestedData()
  }
}



// WEBPACK FOOTER //
// ./src/app/dataRectify/weighbridgeData/plantData/plantData.component.ts